export default {
	namespaced: true,
	state: {
		item: {
			outputHtml: '',
		},
	},
}